import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("iframe", {
  class: "m-auto",
  src: "/assets/pdf/supairvision-vision-cgu.pdf",
  width: "1200",
  height: "600",
  type: "application/pdf",
  title: "pdf"
}, null, -1)
const _hoisted_3 = { class: "w-full" }

import { ref, reactive, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { UpdateUserData } from '@/entities/user/types';
import { ElNotification } from 'element-plus';

import {
  useGetCurrentUserQuery, useGetUserQuery,
  useUpdateUserMutation,
} from '@/entities/user/hooks';
import { useForm } from '@/core/hooks/forms';

import {
  NkGroup,
  NkButton,
  NkModal,
  NkHeading,
  NkText,
  NkIcon,
  NkStack,
  NkModalPreventClose
} from '@/core/components';
import { useFormUpdate } from '@/hooks/forms';
import { clearAuthTokens } from 'axios-jwt';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserUpdateStatusModal',
  emits: [],
  setup(__props, { emit }) {

const ACCEPT = 1;
const REFUSE = 0;

const open = ref(true);
const openDeclineModal = ref(false);


const { onSubmitted } = useForm(emit);

const { t } = useI18n();
const router = useRouter();

const { data: currentUserData } = useGetCurrentUserQuery();

const queryData = computed(() => ({
  id: currentUserData?.value?.id,
}));

const status = currentUserData.value?.status;

const fields = reactive({} as UpdateUserData);

const form = ref();

const {
  mutation: {
    mutateAsync,
    isError,
    isLoading: isUpdateLoading,
  },
} = useFormUpdate({
  fields,
  queryData,
  mutationHook: useUpdateUserMutation,
  queryHook: useGetUserQuery,
});


const submit = (newStatus: number) => {
  open.value = false;
  fields.status = newStatus;
  if (!isUpdateLoading.value) {
    mutateAsync(
      fields,
      {},
    ).then((data: any) => {
      onSubmitted(data);
      if (data?.status === 0) {
        ElNotification({
          message: t('resource.cgu.logout'),
          type: 'error',
          position: 'bottom-right',
        })
        clearAuthTokens();
        router.push('/login');
      }
    });
  }
};

const declineSubmit = () => {
  openDeclineModal.value = false;
  submit(REFUSE);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NkModalPreventClose), {
      modelValue: open.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((open).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(NkGroup), { spacing: 4 }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkHeading), { type: "small-bold" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('resource.cgu.title')), 1)
                ]),
                _: 1
              }),
              _hoisted_2
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NkGroup), {
          spacing: 4,
          position: "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NkButton), {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (submit(ACCEPT))),
              type: "success"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('actions.accept')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(NkButton), {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openDeclineModal.value = !openDeclineModal.value)),
              type: "danger"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('actions.refuse')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(NkModal), {
      modelValue: openDeclineModal.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((openDeclineModal).value = $event)),
      class: "w-fit"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(NkStack), { spacing: 4 }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkText), { align: "center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('resource.cgu.refuse_confirm')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(NkGroup), { spacing: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkIcon), {
                    class: "text-danger",
                    name: "NkInfo"
                  }),
                  _createVNode(_unref(NkText), {
                    class: "!text-danger",
                    type: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('resource.cgu.refuse_text')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NkGroup), {
          spacing: 4,
          position: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NkButton), {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (openDeclineModal.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('actions.cancel')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(NkButton), {
              onClick: declineSubmit,
              type: "danger"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('actions.refuse')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})